import { getRelativeTimeString } from '../utils/formatters';

$(function() {
    $('#roster ol li')
        .each(function() { getWorkshopRoster( $(this) ); });
});

$(document).on('blur', '#roster .row input', e => {
    saveReg($(e.currentTarget).parents('[data-itemid]'));
});

$(document).on('click', '[data-copy]', function() {
    var rows = $(this).parent('li').siblings();
    var exclude = $(this).parents('ol').data('id');
    var workshops = $('ol[data-id!="'+ exclude +'"]');

    rows.each((i, row)=>{
        var index = $(row).data('row');

        workshops.each((j, workshop) => {
            copyReg($(row), $(workshop).find('li[data-row="'+ index +'"]'));
        });
    });
});

$(document).on('click', '[data-save-button]', (e) => {
    const $el = $(e.currentTarget);

    $el.text('Saving...');

    const promises = [];

    $('[data-itemid]').each((i, el) => {
        promises.push(saveReg($(el)));
    });

    Promise.all(promises).then(() => {
        $el.text('Attendees Saved!');
        setTimeout(() => {
            $el.text('Save Attendee Information');
        }, 2000);
    });
});

function getWorkshopRoster(el) {
    var itemid = el.data('itemid');
    var row = el.data('row');

    $.ajax({
        method: 'get',
        url: '/store/roster/',
        data: { itemid, row, csrfmiddlewaretoken: $('[name="csrfmiddlewaretoken"]').val() }
    }).then(data => {
        try {
            setReg(data, el);
        } catch (e) {}
    });
}

function saveReg(regContainer) {
    if (regContainer.find('input').filter(isNotEmpty).length == 0){
        return;
    }

    regContainer.find('[data-lastsaved]').html('Saving');

    return $.ajax({
        method: 'post',
        url: '/store/roster/',
        data: { 
            event: regContainer.parent('ol').data('productcode'),
            first_name: regContainer.find('[name="first_name"]').val(),
            last_name: regContainer.find('[name="last_name"]').val(),
            email: regContainer.find('[name="email"]').val(),
            title: regContainer.find('[name="title"]').val(),
            grade: regContainer.find('[name="grade"]').val(),
            school_name: regContainer.find('[name="school"]').val(),
            uuid: regContainer.find('[name="uuid"]').val(),
            order_item: regContainer.data('itemid'),
            csrfmiddlewaretoken: $('[name="csrfmiddlewaretoken"]').val()
        }
    }).then(data => {
        return new Promise((approve) => {
            try {
                setReg(data, regContainer);
            } catch (e) {}

            approve();
        });
    });
}

function setReg(r, regContainer) {
    var data = JSON.parse(r);

    regContainer.find('[name="first_name"]').val(data.first_name);
    regContainer.find('[name="last_name"]').val(data.last_name);
    regContainer.find('[name="email"]').val(data.email);
    regContainer.find('[name="title"]').val(data.title);
    regContainer.find('[name="grade"]').val(data.grade);
    regContainer.find('[name="school"]').val(data.school_name);
    regContainer.find('[name="uuid"]').val(data.uuid);
    regContainer.find('[data-lastsaved]').html('Last saved ' + getRelativeTimeString(new Date(data.modified_date)));
}

function copyReg(source, target) {
    if (source.find('input').filter(isNotEmpty).length == 0){
        return;
    }

    target.find('[name="first_name"]').val(source.find('[name="first_name"]').val());
    target.find('[name="last_name"]').val(source.find('[name="last_name"]').val());
    target.find('[name="email"]').val(source.find('[name="email"]').val());
    target.find('[name="title"]').val(source.find('[name="title"]').val());
    target.find('[name="grade"]').val(source.find('[name="grade"]').val());
    target.find('[name="school"]').val(source.find('[name="school"]').val());

    target.find('[name="first_name"]').trigger('blur');
}

function isNotEmpty() {
    return $.trim($(this).val()).length > 0;
}
